import React, { useMemo, useState } from "react";
import { CiFilter } from "react-icons/ci";

import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AFilterForm from "../../../../components/AFilterForm/AFilterForm";
import FilterCountBadge from "./FilterCountBadge";
import { dashBoardFilterBtnStyle } from "../../cheque-management/utils";
const btnStyle = {
  color: "black",
  ...dashBoardFilterBtnStyle
};

const CashLocationFilterDrawer = ({
  applyFilterHandler,
  onRemoveFilterHandler,
  dropdownValues,
  filterCount,
  liveBranches =[],
  isCheque = false,
}) => {
  const [filterForm, setFilterForm] = useState({});

  const handleFilterForm = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };

  const removeFilterHandler = () => {
    onRemoveFilterHandler();
    setFilterForm({});
  };

  const formConfig = useMemo(() => {
    return [
      {
        label: "Business Unit",
        type: "select",
        formKey: "businessAreas",
        items: liveBranches || [],
        placeholder: "Select",
        colSpan: 2,
        isMulti: true,
        isShowCount: true,
      },

      {
        label: "Cashier’s Office",
        type: "select",
        formKey: "cashierOffices",
        items: dropdownValues?.cashierOffices,
        placeholder: "Select",
        colSpan: 2,
        isMulti: true,
        isShowCount: true,
      },
      {
        label: `${isCheque ? "Cheque" : "Receipt"} Date from`,
        type: "date",
        formKey: "startDate",
        placeholder: "Select Date",
        colSpan: 2,
        maxDate: filterForm?.endDate
      },
      {
        label: `${isCheque ? "Cheque" : "Receipt"} Date to`,
        type: "date",
        formKey: "endDate",
        placeholder: "Select Date",
        colSpan: 2,
        minDate: filterForm?.startDate
      },
    ];
  }, [dropdownValues, liveBranches, filterForm]);

  return (
    <AFilterForm
      btnComponent={
        <div>
          <AButton
            updatedStyle={btnStyle}
            variant={"general"}
            size="xs"
            className="no-ml-btn"
          > 
          <CiFilter size={18} style={{ marginRight: "4px" }} /> 
            Filters
          </AButton>
          <FilterCountBadge count={filterCount} />
        </div>
      }
      formFields={formConfig}
      filterForm={filterForm}
      handleFilterForm={handleFilterForm}
      applyFilterHandler={applyFilterHandler}
      removeFilterHandler={removeFilterHandler}
    />
  );
};

export default CashLocationFilterDrawer;
